import * as React from 'react';
import Loader from 'components/loader';
import styles from './index.module.css';

export default () => (
  <div className={styles.loader}>
    <Loader size="large" />
  </div>
);
